import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { Props } from './content-card-buttons.constants';
import { ContentCardButtonsWrapper } from './content-card-buttons.style';
import ExpandButton from '../content-card/actions/expand-button';
import AssignButton from 'approot/shared/assign/assign-button';

const ContentCardButtons = ({
  canBookmark,
  canLink,
  link,
  isSmall,
  onLinkClick,
  bookmarkData,
  disableBookmark,
  disableBookmarkTooltipText,
}: Props & {
  isSmall?: boolean;
}) => {
  return (
    <ContentCardButtonsWrapper data-selector="button-wrapper">
      {canBookmark && bookmarkData && (
        <>
          {disableBookmark && disableBookmarkTooltipText ? (
            <TooltipWrapper multiline hoverText={disableBookmarkTooltipText}>
              <AssignButton
                variant="secondary"
                dataSelector="bookmark"
                isSmall={isSmall}
                isDisabled
                assigned={bookmarkData.bookmarked}
              />
            </TooltipWrapper>
          ) : (
            <AssignButton
              variant="secondary"
              isSmall={isSmall}
              assigned={bookmarkData.bookmarked}
              dataEvent={{
                category: bookmarkData.bookmarkDataEvent,
                action: bookmarkData.bookmarkDataEventAction,
                data: bookmarkData.bookmarkDataEventLabel,
              }}
              onAssignSelect={bookmarkData?.onBookmarkClick}
            />
          )}
        </>
      )}
      {canLink && link && (
        <ExpandButton
          link={link}
          isSmall={isSmall}
          ariaLabel="Open link"
          onLinkClick={onLinkClick}
        />
      )}
    </ContentCardButtonsWrapper>
  );
};

export default ContentCardButtons;
